import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import SearchPanel from "@widgets/SearchPanel"; // 조회조건 Panel
import { callApi, fnGetDataSet, fnSave } from "@shared/api/restApi"; // BackEnd API
import {
  getCodeData,
  getInitFormData,
  getAutoSlip,
} from "@shared/utils/CommonUtils"; // 공통 유틸 메뉴 초기화(조회조건, 그리드, 프리폼) 설정 load 관련 내용
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import { global } from "@shared/libs/Global"; // Login User관련 전역 변수( 로그인 정보)
import SnGrid from "@shared/components/Grid/SnGrid"; // 공통 그리드
import SN_MTL_RVW_REG_001_POP_01 from "@menu/MTL/SN_MTL_RVW_REG_001/SN_MTL_RVW_REG_001_POP_01";
import { menuInfo } from "@shared/type/CommonType"; // 공통 Interface
import SnResizableUND from "@shared/components/SnResizableUND"; // Resize 관련
import { showPopupModal } from "@widgets/CommonModal";
import SnButton from "@shared/components/SnButton";

import { CellValueChangedEvent, Column } from "ag-grid-community";
import { CellFocusedEvent } from "ag-grid-enterprise";
interface Props {
  Menuprops: menuInfo;
}
interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_MTL_RVW_REG_001 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const gridApiRefH = useRef<any>(null); // 첫 번째  그리드 Reference 변수
  const searchRef = useRef<any>(null);
  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
  const { userInfo } = global(); // Login user 정보
  //#endregion

  //#region  Components useState
  const [formData, setFormData] = useState<any>(); // 조회조건 변수
  const [formControlData, setFormControlData] = useState<any[]>([]); // 조회조건 설정된 항목 binding
  const [columns1, setColums1] = useState<any[]>([]); // gridApiRefH 컬럼 설정 관련
  const [dataSource1, setDataSource1] = useState<any[]>([]); // gridApiRefH datasource 관련

  const [boolState, setBool] = useState<Boolean>(false);
  const [noReview, setReview] = useState<String>("");
  let edit_enabled: Boolean = true;
  //#endregion

  //#region grid 높이 관련
  let height1 = "49.5%";
  const menuSize = localStorage.getItem("menuSize");
  if (menuSize) {
    const menu = JSON.parse(menuSize);
    height1 = menu.SN_MTL_RVW_REG_001?.grid1Height
      ? menu.SN_MTL_RVW_REG_001?.grid1Height
      : height1;
  }

  const [grid1Height, setGrid1Height] = useState<string | number>(height1);

  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      setDataSource1([]);
      try {
        const defaultForm = {
          cd_biz: userInfo.cd_biz,
          cd_emp: userInfo.cd_emp,
          nm_emp: userInfo.nm_emp,
          cd_gp: userInfo.cd_gp,
          dt: todayform,
        };
        const rtn: any = await getInitFormData();

        setFormControlData(rtn.formControlData);

        setFormData({ ...rtn.formData, ...defaultForm });

        setColums1(rtn.grid.grid1);
      } catch (error) {}
    };
    fetchform();
  }, []);

  //#region  Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onAddRow,
    onDeleteRow,
    onSave,
  }));

  const onSearch = async () => {
    try {
      const popDate = new Date();
      popDate.setDate(1);
      const firstDayOfMonth = `${popDate.getFullYear()}${(
        popDate.getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}${popDate.getDate().toString().padStart(2, "0")}`;

      const selectedFormData = searchRef.current.getFormdata();
      const selectedData = {
        cd_biz: selectedFormData.cd_biz,
        dt_from: firstDayOfMonth,
        dt_to: todayform,
      };
      const component = (
        <SN_MTL_RVW_REG_001_POP_01 selectedData={selectedData} />
      );
      const result = await showPopupModal({
        title: "재고실사등록",
        children: component,
      });
      if (!result || result === "close") return;
      const headerResult = result[0];

      const newParams = {
        cd_firm: headerResult[0].cd_firm,
        no_review: headerResult[0].no_review,
        cd_biz: headerResult[0].cd_biz,
        dt: headerResult[0].dt_review,
        cd_wh: headerResult[0].cd_wh,
      };
      const params = {
        id: "sn_mtl_rvw_reg_001_01",
        params: { ...newParams },
      };

      setDataSource1([]);
      const data: any = await fnGetDataSet(params);
      setDataSource1(data[0]);

      setReview(headerResult[0].no_review);
      setBool(true);
      const newFormdata = {
        cd_biz: headerResult[0].cd_biz,
        dt: headerResult[0].dt_review,
        cd_wh: headerResult[0].cd_wh,
        nm_wh: headerResult[0].nm_wh,
        cd_gp: headerResult[0].cd_gp,
        cd_emp: headerResult[0].cd_emp,
        nm_emp: headerResult[0].nm_emp,
      };
      setFormData({ ...formData, ...newFormdata });

      if (headerResult[0].no_adjust === "Y") {
        edit_enabled = false;
      } else {
        edit_enabled = true;
      }

      if (data[0] && data[0].length > 0) {
        await new Promise((resolve) => setTimeout(resolve, 50));

        gridApiRefH.current.selectAndFocusRow(0);
      }

      gridApiRefH.current.resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onInsert = async () => {
    try {
      const dt = gridApiRefH.current.getChange();
      if (dt !== null) {
        const conFirm = await showDialog(
          "confirm",
          "저장되지 않은 내역은 초기화됩니다. 진행하시겠습니까?"
        );
        if (!conFirm) {
          return;
        }
      }

      gridApiRefH.current?.deleteAllRows();
      gridApiRefH.current.resetUpdate();

      const formNewdata = {
        cd_biz: userInfo.cd_biz,
        dt: todayform,
        cd_wh: "",
        cd_gp: userInfo.cd_gp,
        cd_emp: userInfo.cd_emp,
        //  nm_emp: userInfo.nm_emp,
      };
      setFormData({ ...formData, ...formNewdata });
      setReview("");
      setBool(false);
    } catch (error: any) {}
  };

  const onDelete = async () => {
    if (!edit_enabled) {
      showDialog("alter", "이미 진행된 건입니다.");
      return;
    }

    if (noReview === "") {
      gridApiRefH.current?.deleteAllRows();
      gridApiRefH.current.resetUpdate();
      const formNewdata = {
        cd_biz: userInfo.cd_biz,
        dt: todayform,
        cd_wh: "",
        cd_gp: userInfo.cd_gp,
        cd_emp: userInfo.cd_emp,
        nm_emp: userInfo.nm_emp,
      };
      setFormData({ ...formData, ...formNewdata });
    } else {
      const confirm = await showDialog("confirm", "삭제 하시겠습니까?");
      if (!confirm) {
        return;
      }
      const params = {
        cd_firm: userInfo.cd_firm,
        no_review: noReview,
      };
      const result: any = await callApi(
        "SN_MTL_RVW_REG_01_btnOndelete",
        params
      );

      if (result) {
        gridApiRefH.current?.deleteAllRows();
        gridApiRefH.current.resetUpdate();
      }

      const formNewdata = {
        cd_biz: userInfo.cd_biz,
        dt: todayform,
        cd_wh: "",
        cd_gp: userInfo.cd_gp,
        cd_emp: userInfo.cd_emp,
        nm_emp: userInfo.nm_emp,
      };
      setFormData({ ...formData, ...formNewdata });
    }
    setBool(false);
    setReview("");
  };

  const onAddRow = async () => {
    try {
      if (!edit_enabled) {
        showDialog("alter", "이미 진행된 건입니다.");
        return;
      }
      if (!controlNullCheck()) return;

      const newRow = {};
      gridApiRefH.current?.addRow(newRow);
      //need control enable/disable logic
    } catch (error: any) {}
  };

  const onDeleteRow = async () => {
    if (!edit_enabled) {
      showDialog("alter", "이미 진행된 건입니다.");
      return;
    }
    gridApiRefH.current?.deleteSelectedRows();
    //need control enable/disable logic
  };

  const onBeforeAddRowH = (newRow: RowData): boolean => {
    try {
      const rowCount = gridApiRefH.current.api.getDisplayedRowCount();

      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        no_line: rowCount + 1,
        cd_item: "",
        nm_item: "",
        dc_item_spec: "",
        dc_item_unit: "",
        qt_inv_good: 0,
        qt_inv_bad: 0,
        qt_inv_rcl: 0,
        qt_inv: 0,
        qt_review_good: 0,
        qt_review_bad: 0,
        qt_review_rcl: 0,
        qt_review: 0,
        dc_rmk: "",
        no_review: "",
        cd_wh: "",
        nm_wh: "",
        dt_review: "",
        cd_emp: "",
        nm_emp: "",
      };

      Object.assign(newRow, updatedRow);
      return true;
    } catch (error: any) {
      return false;
    }
  };

  const onSave = async () => {
    let no_slip: any;
    const dt = [];
    let mtlReviewlChanges;
    const searchFormData = searchRef.current.getFormdata();
    const params = await getCodeData(
      "",
      `select cd_dept from mas_emp 
     where cd_firm = '${userInfo.cd_firm}' 
     and cd_emp = '${searchFormData.cd_emp}'`,
      false
    );
    try {
      gridApiRefH.current.api.stopEditing();
      const requiredValuesCheckH = gridApiRefH.current.requiredValuesCheck();

      if (!requiredValuesCheckH) {
        return;
      }

      mtlReviewlChanges = gridApiRefH.current.getChange();
      const lineInserts = mtlReviewlChanges.insert ?? [];

      if (mtlReviewlChanges.modifiedRowcount === 0) {
        showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }
      if (!boolState) {
        const cd_module: any = Menuprops.cd_module;
        const cd_menu: any = Menuprops.cd_menu;
        no_slip = await getAutoSlip(cd_module, 13, searchFormData.dt, cd_menu);
      }
      for (let row of lineInserts) {
        if (!row.no_review) {
          if (boolState) {
            row.no_review = noReview;
          } else {
            row.no_review = no_slip;
          }
        }
      }
      if (!boolState) {
        const newData = {
          cd_firm: userInfo.cd_firm,
          cd_biz: searchFormData.cd_biz,
          cd_wh: searchFormData.cd_wh,
          dt_review: searchFormData.dt,
          cd_dept: params[0]["cd_dept"],
          cd_emp: searchFormData.cd_emp,
          cd_gp: searchFormData.cd_gp,
          no_review: no_slip,
        };
        dt.push(newData);
      }
      const SaveData = {
        mtl_reviewh: { insert: dt },
        mtl_reviewl: mtlReviewlChanges,
      };

      await fnSave("SN_MTL_RVW_REG_01_SAVE_01", SaveData);
      gridApiRefH.current.resetUpdate();
    } catch (error: any) {
      gridApiRefH.current.resetUpdate();
    }
  };
  //#endregion

  //#region  Event Method
  const onGrid2BtnsClick = async (id: string) => {
    if (id === "addRow") {
      onAddRow();
    }

    if (id === "deleteRow") {
      onDeleteRow();
    }
  };
  const onGrid1BtnsClick = async (id: string) => {
    let existH: boolean = false;
    let dt = gridApiRefH.current.getChange();

    if (id == "btnApp") {
      const selectedFormData = searchRef.current.getFormdata();
      if (!controlNullCheck()) return;

      const getRenderedNodes = gridApiRefH.current.api.getRenderedNodes();

      for (const node of getRenderedNodes) {
        if (!node?.data) continue;

        if (node.data.no_review !== "") {
          existH = true;
          break;
        }
      }

      if (existH) {
        showDialog("alter", "조회 중에 자재재고전개를 할 수 없습니다.");
        return;
      }

      if (dt !== null) {
        const conFirm = await showDialog(
          "confirm",
          "저장되지 않은 내역은 초기화됩니다. 진행하시겠습니까?"
        );
        if (!conFirm) {
          return;
        }
      }
      //Searching!!
      //SP for this search uses FN_MTL_INVENTORY that haven't yet created, as main.

      const searchCtr = searchRef.current.getFormdata();
      const newParams2: any = {
        cd_firm: userInfo.cd_firm,
        cd_biz: userInfo.cd_biz,
        dt: searchCtr.dt,
        cd_wh: searchCtr.cd_wh,
        cd_item: "",
        fg_item: searchCtr.fg_item,
        fg_acct: searchCtr.fg_acct,
        tp_item: searchCtr.tp_item,
        cd_mgmt1: searchCtr.cd_mgmt1,
        cd_mgmt2: searchCtr.cd_mgmt2,
        cd_mgmt3: searchCtr.cd_mgmt3,
      };
      const params2 = {
        id: "sn_mtl_rvw_reg_001_buttonSearch",
        params: { ...newParams2 },
      };
      const data: any = await fnGetDataSet(params2);
      const headerResult: any[] = data[0];
      headerResult.map((result: any) => {
        if (headerResult[0]) {
          onAddRow();
          const rowCount = gridApiRefH.current.api.getDisplayedRowCount();
          const lastRowIndex = rowCount - 1;

          const lastRowNode =
            gridApiRefH.current.api.getDisplayedRowAtIndex(lastRowIndex);

          if (lastRowNode) {
            gridApiRefH.current.setValue(
              lastRowNode,
              "cd_item",
              result.cd_item
            );
            gridApiRefH.current.setValue(
              lastRowNode,
              "nm_item",
              result.nm_item
            );
            gridApiRefH.current.setValue(
              lastRowNode,
              "dc_item_unit",
              result.dc_item_unit
            );
            gridApiRefH.current.setValue(
              lastRowNode,
              "dc_item_spec",
              result.dc_item_spec
            );
            gridApiRefH.current.setValue(
              lastRowNode,
              "qt_inv_good",
              result.qt_good
            );
            gridApiRefH.current.setValue(
              lastRowNode,
              "qt_inv_bad",
              result.qt_bad
            );
            gridApiRefH.current.setValue(
              lastRowNode,
              "qt_inv_rcl",
              result.qt_rcl
            );
            gridApiRefH.current.setValue(lastRowNode, "qt_inv", result.qt);
            gridApiRefH.current.setValue(
              lastRowNode,
              "qt_review_good",
              result.qt_good
            );
            gridApiRefH.current.setValue(
              lastRowNode,
              "qt_review_bad",
              result.qt_bad
            );
            gridApiRefH.current.setValue(
              lastRowNode,
              "qt_review_rcl",
              result.qt_rcl
            );
            gridApiRefH.current.setValue(
              lastRowNode,
              "qt_review",
              result.qt_good + result.qt_bad + result.qt_rcl
            );
          }
        }
      });
      edit_enabled = true;
    }
  };

  const controlNullCheck = (): boolean => {
    const searchCtr = searchRef.current.getFormdata();
    if (searchCtr.cd_biz === "") {
      showDialog("alter", "사업장이 입력되지 않았습니다.");
      return false;
    } else if (searchCtr.dt === "") {
      showDialog("alter", "실사일이 입력되지 않았습니다.");
      return false;
    } else if (searchCtr.cd_wh === "") {
      showDialog("alter", "창고가 입력되지 않았습니다.");
      return false;
    }
    if (searchCtr.cd_emp === "") {
      showDialog("alter", "담당자가 입력되지 않았습니다.");
      return false;
    }

    return true;
  };
  const onCellValueChanged = async (event: any) => {
    if (!event) return;
    const updatedColumnId = event.column.getColId();
    //event for multicodebox can't be triggered
    if (updatedColumnId === "cd_item") {
    }
  };

  //#endregion

  //#region  UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex-1">
        <SnGrid
          // Pros로 받은 Menuprops
          seq={1} // Grid Seqno 우클릭 메뉴용
          ref={gridApiRefH} // Grid Name
          columnConfig={columns1} // 컬럼 설정 전달
          rowData={dataSource1} // Datasource
          isEditable={true} // 수정 가능여부
          rowSelection="single" // 로우 선택 모드 (단일)
          onBeforeAddRow={onBeforeAddRowH} // 행추가 전 유효성 체크 및 초기값 설정
          onCellValueChanged={onCellValueChanged}
          onBtnAddClick={onGrid2BtnsClick}
          onBtnDeleteClick={onGrid2BtnsClick}
          title="  " // 그리드 타이틀 정보
          header={
            <div>
              <SnButton
                text={"자재재고전개"}
                onClick={() => {
                  onGrid1BtnsClick("btnApp");
                }}
              />
            </div>
          }
        />
      </div>
    </div>
  );
  //#endregion
});

export default SN_MTL_RVW_REG_001;
